import React, { useRef, useCallback } from 'react'
import { GoogleMap, useLoadScript } from '@react-google-maps/api'
import Busca from './Busca'
import Marca from './Marca'
import Url from '../../util/Url'

const libraries = ["places"]
const containerStyle = {
    height: `300px`
}

export default function Mapa(props) {

    const {isLoaded, loadError} = useLoadScript({
        googleMapsApiKey:Url.obterGoogleMapsApiKey(),
        libraries,
    })

    const mapRef = useRef()

    const onMapLoad = useCallback( map => {
        mapRef.current = map
    }, [])

    const panTo = useCallback(({ lat, lng }) => {
        mapRef.current.panTo({ lat, lng })
        mapRef.current.setZoom(14)
    }, )


    if (loadError) return "Error Loading Maps"
    if (!isLoaded) {
        return null
    }
    
    return (
        <>
            <Busca panTo={ panTo } dados={ props.dados } setDados={ props.setDados } />
            <GoogleMap
                mapContainerStyle={ containerStyle }
                zoom={ props.dados.isMarkerShow? 18 : 8 }
                center={{ lat:props.dados.endereco.latitude, lng:props.dados.endereco.longitude }}
                options={{ disableDefaultUI:!props.dados.isMarkerShow }}
                onLoad={ onMapLoad }
            >
                <Marca dados={ props.dados } setDados={ props.setDados } />
            </GoogleMap>
        </>
    )
}